import { useTheme } from "@up/data";

import { UPLink } from "./up-link";

export const Page404 = function Page404() {
  const theme = useTheme();

  return (
    <div className="mx-auto max-w-[800px] pl-8 pr-8">
      <div className="lg:pb-18 lg:pt-18 pb-12 pt-12 text-gray-900">
        <h1 className={theme.heading1Class}>
          Sorry, we can’t seem to find what you are looking for.
        </h1>
        <p className="mb-6">
          You have landed on a page that does not exist or has been moved. Here
          are some links that could be helpful:
        </p>
        <ul className="list-disc">
          <li className="mb-4">
            To start from the beginning,{" "}
            <UPLink className="underline" href="/">
              go to the home page
            </UPLink>
          </li>
          <li className="mb-4">
            If you think this is an error, please{" "}
            <a className="underline" href={`mailto:${theme.supportEmail}`}>
              email support
            </a>
          </li>
          <li className="mb-4">
            Maybe you can find what you need on the{" "}
            <UPLink className="underline" href="/sitemap">
              sitemap
            </UPLink>
          </li>
        </ul>
      </div>
    </div>
  );
};
